import React, { useState, useEffect } from 'react';
import { Get } from '../../../hooks/useFetch';

const MINUTE_MS = 60000;

import { createContext, useContext } from 'react';
import { useSelector } from 'react-redux';
import { Loader } from '../../../components/dataLoading';
import { cacheGet, cacheRemove } from '../../../util/cache';

const TokenContext = createContext();

// Use Token function
export const useToken22 = () => {
  const context = useContext(TokenContext);
  if (!context) {
    throw new Error('useToken must be used within a TokenProvider');
  }
  return context;
};

// eslint-disable-next-line react/prop-types
export const TokenProvider = ({ clearToken, children }) => {
  const isLoading = useSelector((state) => state.loader.isLoading);
  return (
    <TokenContext.Provider value={{ clearToken }}>
      {isLoading && <Loader />}
      {children}
    </TokenContext.Provider>
  );
};

// Use Token hook

export default function useToken() {
  const [token, setToken] = useState(GetToken());

  const getQueryParam = (name) => {
    const queryString = window.location.search.substring(1);
    const queryParams = queryString.split('&');

    for (let i = 0; i < queryParams.length; i++) {
      const pair = queryParams[i].split('=');
      if (pair[0] === name) {
        return pair[1];
      }
    }

    return null;
  };

  useEffect(() => {
    const ssoToken = getQueryParam('token');
    if (ssoToken) {
      Get(
        `/Authentication/refresh/${ssoToken}`,
        (response) => {
          saveToken(response);
        },
        () => {
          clearToken();
          return null;
        }
      );
    }

    const interval = setInterval(() => {
      var newToken = GetToken();
      if (!newToken) {
        clearToken();
        return;
      }

      if (newToken?.token != token?.token) {
        setToken(newToken);
      }
    }, MINUTE_MS);

    return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, []);

  const saveToken = (userToken) => {
    SaveUser(userToken);
    setToken(userToken?.authToken);
  };

  const clearToken = () => {
    ClearUser();
    setToken();
  };

  return {
    setToken: saveToken,
    clearToken: clearToken,
    token,
  };
}

function SaveUser(userToken) {
  var d = new Date();
  d.setMinutes(d.getMinutes() + 25);

  if (userToken) {
    userToken.expire = d;
    localStorage.setItem('token', JSON.stringify(userToken));
  }
}

function ClearUser() {
  cacheRemove('token');
}

function GetUser() {
  const userToken = cacheGet('token');
  let expire = new Date(userToken?.expire);
  if (isNaN(expire) == false) {
    var now = new Date();
    if (expire <= now) {
      //if it's a newer token, try a rewnew.
      if (expire >= now.setMinutes(now.getMinutes() - 5)) {
        //Update the expire to another minute to give the refresh time to run.
        SaveUser(userToken);

        //Update the new token
        Get(
          `/Authentication/refresh/${userToken.authToken.token}?environmentId=${userToken.authToken.environmentId}`,
          (response) => {
            SaveUser(response);
          },
          () => {
            ClearUser();
          }
        );
      } else {
        ClearUser();
        return null;
      }
    }
  }

  return userToken;
}

function GetToken() {
  const userToken = GetUser();
  return userToken?.authToken;
}

function GetScope() {
  const userToken = GetUser();
  return userToken?.scope;
}

function GetApiToken() {
  const apiToken = localStorage.getItem('apiToken');

  if (!apiToken) {
    console.error('Bearer API token is missing.');
    return null;
  }
  return JSON.parse(apiToken);
}

export { GetToken, GetUser, GetScope, GetApiToken };
